export const HipaaFrameworkId = '790498619';
export const HipaaFrameworkName = 'HIPAA';
